export const NOTIFICATION_INCORRECT_DATE_FIELD = 'dateError'
